import React, { useMemo, useRef } from 'react';
import { AudioManagerContext } from './AudioManager.context';
import { usePlay, useUnregister } from './AudioManger.hooks';
export var AudioManager = function AudioManager(_ref) {
  var children = _ref.children;
  var currentAudio = useRef(null);
  var play = usePlay(currentAudio);
  var unregister = useUnregister(currentAudio);
  var context = useMemo(function () {
    return {
      play: play,
      unregister: unregister
    };
  }, [play, unregister]);
  return /*#__PURE__*/React.createElement(AudioManagerContext.Provider, {
    value: context
  }, children);
};